(function() {
    'use strict';

    angular.module('MW.InsDashboard.GoogleAccountSettings', [
        'MW.DashboardLegacy.Constants',
        'MW.Framework.EntitlementService',
        'MW.InsDashboard.GoogleAccountService',
        'MW.Framework.DialogService',
        'MW.Framework.TranslationService'])
        .component('mwGoogleAccountSettings', {
            templateUrl: ['DASHBOARD_LEGACY_VIEW_PATH', function (DASHBOARD_LEGACY_VIEW_PATH) {
                return DASHBOARD_LEGACY_VIEW_PATH + '/ins_dashboard/views/google_account_settings.html';
            }],
            controller: [
                'EntitlementService',
                'GoogleAccountService',
                'DialogService',
                'translationService',
                GoogleAccountSettingsController
            ]
        });

    function GoogleAccountSettingsController(EntitlementService, GoogleAccountService, DialogService, translationService) {
        var ctrl = this;

        // Helper function to get the user profile information that we need to display
        function getUserProfile() {
            GoogleAccountService.getUserProfile().then(function handleUserProfile(userProfile) {
                ctrl.userProfile = userProfile;
                if (ctrl.userProfile) {
                    ctrl.isAccountEnabled = true;
                }
            });
        }

        ctrl.isGoogleAccountEntitlementEnabled = false;
        ctrl.isAccountEnabled = false;
        ctrl.userProfile = {
            email: '',
            imageUrl: '',
            name: ''
        };

        EntitlementService.getCompanyEntitlement('google-analytics-widget').then(function getCompanyEntitlementThen(entitlement) {
            ctrl.isGoogleAccountEntitlementEnabled = entitlement['google-analytics-widget'].value;

            if(ctrl.isGoogleAccountEntitlementEnabled){
                // Initialize the user profile if we have one
                getUserProfile();
            }
        });

        // Handles signing in to establish a google account
        ctrl.onSignIn = function onSignIn() {
            GoogleAccountService.establishGoogleAccount().then(function handleSignInResponse() {
                getUserProfile();
                //close dialog
            });
        }

        ctrl.openDeleteDialog = function(socialAccountId) {
            var confirmMessageText = translationService.getLocalizedString('google-analytics-account__settings--delete-confirm-description'),
                confirmMessageTitle = translationService.getLocalizedString('google-analytics-account__settings--delete-confirm-title');

            DialogService.confirm(confirmMessageText, confirmMessageTitle, function(payload) {
                if(!payload.success) {
                    return;
                } else { 
                    GoogleAccountService.deleteGoogleAccount(socialAccountId).then( function afterDelete() {
                        ctrl.isAccountEnabled = false;
                        var message = translationService.getLocalizedString('google-analytics-account__settings--delete-success');
                        DialogService.flash(message, 'success');
                    });
                }
            });
        };
    }
})();
